module.exports = __webpack_public_path__ + "static/media/fourthareaproduct4.0be35356.jpg";